<template>
  <i
    v-html="sanitizedSvgContent"
    class="svgIcon"
    :class="c"
    :style="{
      width: boxW,
      height: boxH,
      lineHeight: 0,
      display: 'inline-block'
    }"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import icons from '@/assets/icons/svg_icons'

const props = defineProps<{
  n: keyof typeof icons
  w?: number | string
  h?: number | string
  c?: any
  forceCurrentColor?: boolean
}>()

// แปลงขนาด: เลขล้วน -> px, ถ้ามีหน่วยอยู่แล้วคงเดิม
const normalizeSize = (v: number | string | undefined, fallback = '24px') => {
  if (v === undefined || v === null) return fallback
  const s = String(v).trim()
  // เลขล้วน หรือเลขทศนิยม -> เติม px
  if (/^\d+(\.\d+)?$/.test(s)) return `${s}px`
  return s // มีหน่วยมาแล้ว เช่น 1.5rem, 24px, 2em
}

const boxW = computed(() => normalizeSize(props.w, '24px'))
const boxH = computed(() => normalizeSize(props.h, '24px'))

const sanitizeSvg = (raw: string) => {
  if (!raw) return ''
  const doc = new DOMParser().parseFromString(raw, 'image/svg+xml')

  // ตัดของอันตราย
  doc.querySelectorAll('script, iframe, object, embed').forEach(el => el.remove())
  doc.querySelectorAll<HTMLElement>('*').forEach(el => {
    ;[...el.attributes].forEach(attr => {
      if (attr.name.startsWith('on')) el.removeAttribute(attr.name)
    })
  })

  // คุมขนาดจากภายนอก
  const svg = doc.documentElement
  svg.setAttribute('width', '100%')
  svg.setAttribute('height', '100%')

  // บังคับ currentColor (ค่าเริ่มต้น = true)
  if (props.forceCurrentColor ?? true) {
    svg.querySelectorAll('*').forEach(el => {
      const fill = el.getAttribute('fill')
      if (fill && fill !== 'none') el.setAttribute('fill', 'currentColor')
      const stroke = el.getAttribute('stroke')
      if (stroke && stroke !== 'none') el.setAttribute('stroke', 'currentColor')
    })
  }

  return svg.outerHTML
}

const sanitizedSvgContent = computed(() => sanitizeSvg(icons[props.n] ?? ''))
</script>

<style scoped>
.svgIcon :deep(svg) {
  display: block;
  width: 100%;
  height: 100%;
}
</style>
